import { AbstractMetaTag } from './AbstractMetaTag';

export class HTMLMetaTag extends AbstractMetaTag {
    constructor(name: string, content: string) {
        super('name', name, content);
    }
}
